export const TRIAL_VARIANT_KEY = 'variant_trial';
export const TRIAL_VARIANT_QUERY_KEY = ['clientStorage', TRIAL_VARIANT_KEY] as const;

/**
 * Users created from this moment on are in the C/D experiment. The client can't tell an experiment signup whose
 * assignment is missing from Client Storage from a user created before the experiment (neither has the item), so a
 * missing assignment is recomputed only for users created on or after this date; older users stay outside (`null`).
 */
export const TRIAL_VARIANT_EXPERIMENT_START = '2026-10-08T08:00:00Z';
